import { Organisation } from "../../AppDataProvider/types";
import { PaymentIntegrationType } from "../types";

export const getPaymentIntegrationType = (
  organisation: Organisation,
): PaymentIntegrationType | null => {
  if (organisation.stripeIntegration) {
    return PaymentIntegrationType.STRIPE;
  }
  if (organisation.squareIntegration) {
    return PaymentIntegrationType.SQUARE;
  }
  if (organisation.adyenIntegrationToken) {
    return PaymentIntegrationType.ADYEN;
  }
  return null;
};
